import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  AddDependentRequest,
  DependentsResponse,
  UpdateDependentRequest,
} from './interfaces';
import { edupassClient } from '@/data/@clients';

const queryKey = 'dependents';

export const useDependentsIndex = (collaboratorId?: number) => {
  const response = useQuery<DependentsResponse>({
    queryKey: [queryKey, collaboratorId],
    queryFn: async () =>
      edupassClient.get(`/colaboradores/${collaboratorId}/dependents`),
    enabled: !!collaboratorId,
  });

  return { dependents: response.data?.data, ...response };
};

export const useAddDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (data: AddDependentRequest) =>
      edupassClient.post('/dependents', data),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useUpdateDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (data: UpdateDependentRequest) =>
      edupassClient.post(`/dependents/${data.id}`, data),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useRemoveDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => edupassClient.delete(`/dependents/${id}`),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useResetDependentPassword = () => {
  return useMutation({
    mutationFn: async (id: number) =>
      edupassClient.post(`/dependents/${id}/reset-password`),
  });
};
